import { Parallax, Reveal, ChapterLabel, scrollTo, EASE } from "./Motion";
import { motion, useReducedMotion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { EDITORIAL, WHY_HEARD } from "../../data/content";

export const Ch2 = () => {
  const reduce = useReducedMotion();
  return (
    <section id="chapter-2" className="bg-cream py-24 sm:py-40">
      <div className="mx-auto max-w-[1400px] px-6 sm:px-10">
        <Reveal>
          <Parallax
            src={EDITORIAL.conversation}
            alt="Two people sharing a quiet, supportive moment on a sofa"
            className="h-[52vh] min-h-[360px] w-full rounded-[2rem] sm:rounded-[2.5rem]"
            strength={8}
          />
        </Reveal>

        <div className="mt-14 sm:mt-20 max-w-3xl">
          <Reveal><ChapterLabel index="Chapter Two" /></Reveal>
          <Reveal delay={0.1}>
            <h2 className="serif-display mt-6 text-[2rem] sm:text-[2.7rem] lg:text-[3.4rem] font-normal text-charcoal leading-[1.12]">
              Why We Built HEARD
            </h2>
          </Reveal>

          <div className="mt-8 space-y-6">
            {WHY_HEARD.map((p, i) => (
              <Reveal key={p.slice(0, 24)} delay={0.14 + i * 0.05}>
                <p className="text-lg font-normal sm:font-light leading-[1.9] text-ink/90">{p}</p>
              </Reveal>
            ))}
            <Reveal delay={0.4}>
              <p className="serif-display text-2xl sm:text-3xl italic font-light text-sage-deep">
                Because everyone deserves to be heard.
              </p>
            </Reveal>
          </div>

          <Reveal delay={0.2}>
            <p className="mt-12 text-sm uppercase tracking-[0.2em] text-taupe">
              Help shape a community built on empathy instead of algorithms.
            </p>
          </Reveal>
          <Reveal delay={0.26}>
            <motion.button
              onClick={() => scrollTo("beta")}
              data-testid="ch2-request-access"
              whileHover={reduce ? {} : { scale: 1.03 }}
              transition={{ duration: 0.4, ease: EASE }}
              className="group mt-5 inline-flex items-center gap-2.5 rounded-full bg-sage-deep px-8 py-4 text-sm uppercase tracking-[0.18em] text-cream shadow-[0_12px_30px_rgba(47,75,57,0.24)] transition-colors duration-500 hover:bg-sage"
            >
              Request Early Access
              <ArrowRight size={16} className="transition-transform duration-500 group-hover:translate-x-1" />
            </motion.button>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
